import { render, staticRenderFns } from "./mask.vue?vue&type=template&id=211284db&"
import script from "./mask.vue?vue&type=script&lang=ts&"
export * from "./mask.vue?vue&type=script&lang=ts&"
import style0 from "./mask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports